module.exports = __webpack_public_path__ + "img/horizontal_7_7_5012.a8b1e718.png";